/* eslint-disable no-useless-constructor */
/* global DeferredMedia */

if (!customElements.get('product-model')) {
  class ProductModel extends DeferredMedia {
    constructor() {
      super();
    }

    handleMouseMove(evt) {
      if (!this.modelViewer.classList.contains('shopify-model-viewer-ui__disabled')) {
        evt.preventDefault();
        evt.stopPropagation();
      }
    }

    loadContent() {
      super.loadContent();

      Shopify.loadFeatures([
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: this.setupModelViewerUI.bind(this)
        }
      ]);
    }

    setupModelViewerUI(errors) {
      if (errors) return;

      this.modelViewer = this.querySelector('model-viewer');
      this.modelViewerUI = new Shopify.ModelViewerUI(this.modelViewer);
      this.addEventListener('mousemove', this.handleMouseMove.bind(this));
    }
  }

  customElements.define('product-model', ProductModel);
}

window.ProductModel = {
  loadShopifyXR() {
    Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXR.bind(this)
      }
    ]);
  },

  setupShopifyXR(errors) {
    if (errors) return;

    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', () => this.setupShopifyXR());
      return;
    }

    document.querySelectorAll('[id^="product-json-"]').forEach((modelJSON) => {
      window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
      modelJSON.remove();
    });

    window.ShopifyXR.setupXRElements();
  }
};

window.addEventListener('DOMContentLoaded', () => {
  // VRF CUSTOM: load Shopify's XR script only when a [data-shopify-xr] button is on the page.
  // Product galleries use our own AR link (vrf-ar-link.js), so pages skip the XR script and the
  // Bugsnag script it loads first.
  if (window.ProductModel && document.querySelector('[data-shopify-xr]')) window.ProductModel.loadShopifyXR();
});
